// extracted by mini-css-extract-plugin
module.exports = {"menu":"Report_menu__3Gd31","reportRow":"Report_reportRow__1FbY3"};